export default () => ({
  trigger: {
    name: 'context.view_context',
    params: {},
  },
  config: {
    event: {
      name: 'view_context',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
